import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './CustomStyles.css';
import EditorApp from './EditorApp';
import ClientApp from './ClientApp';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

// Change this line to switch between ClientApp and EditorApp
const isEditor = true;

root.render(
  <React.StrictMode>
    {isEditor ? <EditorApp /> : <ClientApp />}
  </React.StrictMode>
);